import { NgModule } from '@angular/core';

import { AuthForBirthdayRewardsModule } from './forBirthdayRewards';
import { AuthForCellSignInModule } from './forCellSignIn';
import { AuthForCellVerifyModule } from './forCellVerify';
import { AuthForConfirmationModule } from './forConfirmation';
import { AuthForEmailVerifyModule } from './forEmailVerify';
import { AuthForForgotPasswordModule } from './forForgotPassword';
import { AuthForForgotPasswordSentModule } from './forForgotPasswordSent';
import { AuthForMemberCardModule } from './forMemberCard';
import { AuthForPartialMemberPasswordModule } from './forPartialMemberPassword';
import { AuthForRewardsAccountLinkingInfoModule } from './forRewardsAccountLinkingInfo';
import { AuthForRewardsAccountLinkingPasswordModule } from './forRewardsAccountLinkingPassword';
import { AuthForRewardsAccountLinkingSignUpModule } from './forRewardsAccountLinkingSignUp';
import { AuthForSignInPasswordModule } from './forSignInPassword';
import { AuthForSignUpModule } from './forSignUp';
import { AuthForUniqueCodeErrorModule } from './forUniqueCodeError';

import { AuthTypeComponent } from './auth-type.shared.component';

const toExport: any[] = [
    AuthForBirthdayRewardsModule,
    AuthForCellSignInModule,
    AuthForCellVerifyModule,
    AuthForConfirmationModule,
    AuthForEmailVerifyModule,
    AuthForForgotPasswordModule,
    AuthForForgotPasswordSentModule,
    AuthForMemberCardModule,
    AuthForRewardsAccountLinkingPasswordModule,
    AuthForPartialMemberPasswordModule,
    AuthForRewardsAccountLinkingInfoModule,
    AuthForRewardsAccountLinkingSignUpModule,
    AuthForSignInPasswordModule,
    AuthForSignUpModule,
    AuthForUniqueCodeErrorModule,
];

@NgModule({
    declarations: [
        AuthTypeComponent
    ],
    imports: [
        ...toExport,
    ],
    exports: [
        AuthTypeComponent,
        ...toExport,
    ],
})
export class AuthTypesModule { }
